import axios from "./axiosInstance";

const StoreAdminAPI = {
  // get store admin list with filters
  getList: (params) => axios.get("store-admins/lists", { params }),

  addStoreAdmin: (payload) => axios.post("store-admins/register", payload),

  getStoreAdminDetails: (id) => axios.get(`store-admins/details/${id}`),

  updateStoreAdmin: (id, payload) => axios.put(`store-admins/${id}`, payload),

  updatePassword: (id, payload) =>
    axios.patch(`store-admins/password/${id}`, payload),

  deleteItem: (id) => axios.delete(`store-admins/${id}`),

  updateSelectedStore: (payload) => axios.post("store-admins/access-store", payload),
};

export default StoreAdminAPI;
